import { gql } from '@apollo/client';

export const DTOOLS_AUTH_DETAILS_FRAGMENT = gql`
  fragment DtoolsAuthDetails on DtoolsAuthDetails {
    id
    partnerId
    maskedApiKey
    status
    lastValidatedAt
  }
`;
